export const calculateAspectRatio = ({
  creativeMaxHeight,
  creativeMinHeight,
  creativeWidth
}) => {
  if (
    !Number.isInteger(creativeWidth) ||
    !Number.isInteger(creativeMinHeight) ||
    !Number.isInteger(creativeMaxHeight)
  ) {
    return "auto";
  }

  const avgHeight = Math.floor((creativeMinHeight + creativeMaxHeight) / 2);

  return `${creativeWidth} / ${avgHeight}`;
};
